import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpService from '../services/HttpServices';
import { toast } from 'react-hot-toast';

const apiService = HttpService;

const initialState = {
    tags: [],
    tagDispatchData: {},
    garmentTypes: [],
    labels: [],
    totalRecords: 0,
    loading: false,
    error: false
}

export const acknowledgeTagById = async ({ tagId, dispatchId, action }) => {
    const response = await apiService.patch(`tags/${tagId}`, { dispatchId, action });
    // console.log("response",response);
    // toast.success(response.msg)
    return response;
}

export const uploadPdf = async (data) => {
    // console.log("data",data)
    const response = await apiService.post('upload/pdf', data, { headers: { 'Content-Type': 'multipart/form-data' } })
    return response.data
}

export const submitTracerCertificate = async ({ tagId, tracerCertificateName, action }) => {
    const response = await apiService.patch(`tags/${tagId}`, { action, tracerCertificateName });
    // console.log("response",response);
    // toast.success(response.msg)
    return response;
}

export const submitFptGptReport = async ({ tagId, fptGptReportName, action }) => {
    const response = await apiService.patch(`tags/${tagId}`, { action, fptGptReportName });
    // console.log("response",response);
    // toast.success(response.msg)
    return response;
}


export const fetchAllGarmentTypes = createAsyncThunk(
    'tag/fetchAllGarmentTypes',
    async (rejectWithValue) => {
        try {
            // console.log(" fetchAllGarmentTypes TRY BLOCK")
            const response = await apiService.get(`/public/lookups/garment-types`);
            return response.data; // response
        } catch (error) {
            return rejectWithValue(error.response.data || error.message);
        }
    }
);

export const fetchAllLabels = createAsyncThunk(
    'tag/fetchAllLabels',
    async (rejectWithValue) => {
        try {
            const response = await apiService.get(`/public/lookups/labels`);
            return response.data; // response
        } catch (error) {
            return rejectWithValue(error.response.data || error.message);
        }
    }
);

export const fetchTagsByCompanyId = createAsyncThunk(
    'tag/fetchTagsByCompanyId',
    async (queryParams, thunkAPI) => {
        try {
            const response = await apiService.get(`/tags`, { params: queryParams })
            return response.data
        }
        catch (err) {
            return thunkAPI.rejectWithValue(err.response.data || err.message);
        }
    }
)

export const fetchTagDispatchDetails = createAsyncThunk(
    'tag/fetchTagDispatchDetails',
    async (tagId, thunkAPI) => {
        try {
            const response = await apiService.get(`/tags/${tagId}`)
            return response.data
        }
        catch (err) {
            return thunkAPI.rejectWithValue(err.response.data || err.message);
        }
    }
)

export const createTagRequest = createAsyncThunk(
    'tag/createTagRequest',
    async (tag, thunkAPI) => {
        try {
            const response = await apiService.post(`/tags`, tag)
            return response.data
        }
        catch (err) {
            return thunkAPI.rejectWithValue(err.response.data || err.message);
        }
    }
)

export const tagSlice = createSlice({
    name: "tag",
    initialState: initialState,
    reducers: {
        reset: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllGarmentTypes.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAllGarmentTypes.fulfilled, (state, action) => {
                state.loading = false;
                state.garmentTypes = action.payload.data
                // console.log("action.payload.data garmenttypes",action.payload.data);
            })
            .addCase(fetchAllGarmentTypes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchAllLabels.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAllLabels.fulfilled, (state, action) => {
                state.loading = false;
                state.labels = action.payload.data
                // console.log("action.payload.data labels",action.payload.data);
            })
            .addCase(fetchAllLabels.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchTagsByCompanyId.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchTagsByCompanyId.fulfilled, (state, action) => {
                // console.log("action.payload",action.payload)
                state.loading = false;
                state.tags = action.payload.data;
                state.totalRecords = action.payload.totalRecords;
            })
            .addCase(fetchTagsByCompanyId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchTagDispatchDetails.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchTagDispatchDetails.fulfilled, (state, action) => {
                // console.log("action.payload in fetchTagDispatchDetails",action.payload)
                state.loading = false;
                state.tagDispatchData = action.payload.data;
            })
            .addCase(fetchTagDispatchDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createTagRequest.pending, (state) => {
                state.loading = true;
            })
            .addCase(createTagRequest.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(createTagRequest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
})

export const { reset } = tagSlice.actions

export default tagSlice.reducer;